module.exports = __webpack_public_path__ + "img/29-0e13ab.png";